import { SmileOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { Link } from "react-router";
import { RoutePaths } from "../routes";

export default function UnderConstruction() {
  return (
    <Result
      icon={<SmileOutlined />}
      title="Under construction"
      subTitle="This page is under construction, please come back later"
      extra={
        <Link to={RoutePaths.root} viewTransition>
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
}
